import { useBi } from '@wix/yoshi-flow-editor';
import { bookingsBoWaiverAppSrc16Evid66 } from '@wix/bi-logger-bookings-data/v2';

export const BI_COMPONENT = 'waiver form';
export const BI_PAGE_NAME = 'intake form';

export const BI_ACTION = {
  LOAD: 'load',
  CLICK: 'click',
} as const;

export const BI_VALUE = {
  EMPTY: '',
  CLOSE: 'x',
  SUBMIT: 'submit',
} as const;

export const useWaiverSignWidgetBI = () => {
  const biLogger = useBi();

  const WaiverFormActionsBI = ({
    action,
    value,
  }: {
    action?: string;
    value?: string;
  }) => {
    biLogger.report(
      bookingsBoWaiverAppSrc16Evid66({
        component: BI_COMPONENT,
        action,
        value,
        pageName: BI_PAGE_NAME,
      }),
    );
  };

  return {
    WaiverFormActionsBI,
  };
};
